import { useEffect, useState } from "react";
import { upsertTag, uuidMapping } from "../helper";

export const useGenderFilter = (talentFilter, talentFilterTags) => {
  const [selectedGender, setSelectedGender] = useState([]);

  useEffect(() => {
    const attr = talentFilter?.person_attributes?.find(
      attribute => attribute && attribute.person_attribute_uuid === uuidMapping.gender
    );

    if (attr?.list) setSelectedGender(attr.list);
  }, []);

  useEffect(() => {
    const exists = talentFilter?.person_attributes?.some(
      attribute => attribute && attribute.person_attribute_uuid === uuidMapping.gender
    );

    if (!exists) {
      clearGender();
    }
  }, [talentFilter]);

  const clearGender = () => {
    setSelectedGender([]);
  };

  const buildGenderFilter = (genderNames) => {
    if (!selectedGender.length) return null;

    const genderAttribute = {
      person_attribute_uuid: uuidMapping.gender,
      contains: false,
      has_all_in_list: false,
      list: selectedGender,
      start_value: null,
      end_value: null,
    };

    const tags = upsertTag(
      talentFilterTags,
      uuidMapping.gender,
      genderNames
    );

    return { attribute: genderAttribute, tags };
  };

  return {
    selectedGender,
    setSelectedGender,
    buildGenderFilter,
    clearGender
  };
};
